import React from 'react';
import './NotificationList.scss';
import { Loader } from 'components/Loader/Loader';
import { useNotificationListVM } from './useNotificationListVM';
import { Notification } from 'services/notification/notification.types';
import moment from 'moment';
import 'moment/locale/fr';
import { getNotificationContent, getNotificationRouting } from 'utils/notificationFormatter';
import { useNavigate } from 'react-router-dom';
moment.locale('fr'); // Configuration de la locale française

export const NotificationList: React.FC<{ setUnreadCount: (count: number) => void, setIsOpen: (isOpen: boolean) => void }> = ({ setUnreadCount, setIsOpen }) => {
    const { notifications, isLoading, handleScroll, isUninitialized } = useNotificationListVM(setUnreadCount);
    const navigate = useNavigate();

    return (
        <div className="notification-list">
            <div className="notification-list-content" onScroll={handleScroll}>
                {notifications.map((notification: Notification) => (
                    <div 
                        onClick={() => {
                            navigate(getNotificationRouting(notification.type, notification.entity_id));
                            setIsOpen(false);
                        }}
                        key={notification.id}
                        className={`notification-item ${notification.read ? 'read' : 'unread'}`}
                    >
                        <div className="notification-content">
                            {getNotificationContent(notification.content)}
                        </div>
                        {notification.label && <div className="notification-label">
                            {notification.label}
                        </div>}
                        <div className="notification-time">
                            {moment(notification.created_at).fromNow()}
                        </div>
                    </div>
                ))}
                
                {(isLoading || isUninitialized) && <Loader />}
                
                {!isLoading && notifications.length === 0 && !isUninitialized && (
                    <div className="notification-empty">
                        Aucune notification
                    </div>
                )}
            </div>
        </div>
    );
};